import React, { useEffect, useState } from 'react';
import * as microsoftTeams from '@microsoft/teams-js';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { GetHomePageData } from 'redux/actions/home';
import Loading from 'components/Loading';
import HomeView from './HomeView';

const Home = (props) => {
  const [darkTheme, setDarkTheme] = useState(false);
  const [loading, setLoading] = useState(true);
  const {
    planName,
    admins,
    subscriptionDetails,
    enagagementData,
    userDetails,
    gameData,
    channelData,
    GetHomePageData: getHomePageData
  } = props;
  
  useEffect(() => {
    microsoftTeams.app.initialize();
    microsoftTeams.app.getContext().then(async (context) => {
      const { user, app, team, chat } = context;
      setDarkTheme(app.theme === 'dark');
      
      // Load home page data
      await getHomePageData(user.tenant.id, user.id);
      
      // Note: Schedule data is not available in Home tab context
      // The QuickAutomation component will handle this gracefully
      
      setLoading(false);
    });
    microsoftTeams.app.notifySuccess();
  }, [getHomePageData]);

  if (loading) {
    return (
      <div style={{ marginTop: '15%' }}>
        <Loading height={100} width={100} />
      </div>
    );
  }

  return (
    <div>
      <HomeView
        darkTheme={darkTheme}
        userDetails={userDetails}
        subscriptionDetails={subscriptionDetails}
        admins={admins}
        planName={planName}
        enagagementData={enagagementData}
        gameData={gameData}
        schedules={props.schedules}
        channelData={channelData}
      />
    </div>
  );
};

Home.propTypes = {
  GetHomePageData: PropTypes.func.isRequired,
  planName: PropTypes.string.isRequired,
  admins: PropTypes.array.isRequired,
  subscriptionDetails: PropTypes.shape({}).isRequired,
  userDetails: PropTypes.shape({}).isRequired,
  enagagementData: PropTypes.shape({}).isRequired,
  gameData: PropTypes.shape({}),
  schedules: PropTypes.shape({
    upcoming: PropTypes.array,
    isAdmin: PropTypes.bool,
    teamName: PropTypes.string
  }),
  channelData: PropTypes.shape({
    allChannels: PropTypes.array
  })
};

const mapStateToProps = ({
  home: { planName, admins, subscriptionDetails, userDetails, enagagementData, gameData, scheduleData, channelData }
}) => ({
  planName,
  admins,
  subscriptionDetails,
  userDetails,
  enagagementData,
  gameData,
  schedules: scheduleData,
  channelData
});

export default connect(mapStateToProps, { GetHomePageData })(Home);
